/**
 * React 18 react-dom/client shim for use with React 16/17.
 * Provides createRoot and hydrateRoot so packages that require React 18
 * (e.g. @ingestro/importer-react) can run. Uses legacy ReactDOM.render/hydrate.
 */
const ReactDOM = require('react-dom');

function createRoot(container) {
  return {
    render(children) {
      ReactDOM.render(children, container);
      return {};
    },
    unmount() {
      ReactDOM.unmountComponentAtNode(container);
    }
  };
}

function hydrateRoot(container, children) {
  ReactDOM.hydrate(children, container);
  return {
    render(children) {
      ReactDOM.render(children, container);
      return {};
    },
    unmount() {
      ReactDOM.unmountComponentAtNode(container);
    }
  };
}

module.exports = {
  createRoot,
  hydrateRoot
};
